import { usePreInstallAsana } from "@/api/useIntegrations"
import { App } from "@/atoms"
import { getDisplayMessage } from "@/helpers/error.helper"
import { goToExternalUrl } from "@/helpers/window.helpers"
import { useTranslation } from "@/hooks/useTranslation"
import { isAsanaAuthorizeUrl } from "@/pages/IntegrationsPage/helpers/ticketing"

// The consent URL carries a single-use OAuth state, so it is only requested on click
export const useAsanaSignIn = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.asana.messages"
  })
  const { message } = App.useApp()
  const preInstall = usePreInstallAsana()

  const signIn = (workspaceGid?: string) =>
    preInstall.mutate(workspaceGid ? { workspaceGid } : undefined, {
      onSuccess: (response) => {
        const url = response?.data?.authorizeUrl

        if (!url || !isAsanaAuthorizeUrl(url)) {
          message.error(t("failed"))
          return
        }

        goToExternalUrl(url)
      },
      onError: (error) => {
        message.error(getDisplayMessage(error) ?? t("failed"))
      }
    })

  return { signIn, isPending: preInstall.isPending }
}
